import React from 'react';
import MaskedInput from 'react-text-mask';

import { Input, Props as InputProps } from './Input';

type Props = InputProps;

export const PhoneInput: React.FC<Props> = (props) => {
  return (
    <MaskedInput
      mask={[
        '(',
        /[1-9]/,
        /[1-9]/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={'\u2000'}
      guide={false}
      onBlur={props.onBlur}
      defaultValue={props.defaultValue}
      onChange={(e) => {
        props.onChange(e.target.value);
      }}
      render={(ref, innerProps) => {
        return (
          <Input
            inputRef={ref}
            {...props}
            onChange={(_, event) => {
              innerProps.onChange(event);
            }}
            onBlur={() => {
              innerProps.onBlur({} as any);
            }}
            defaultValue={innerProps.defaultValue}
          />
        );
      }}
    />
  );
};
